<template>
  <div class="chat">
    <div class="chat__message-container">
      <ChatMessages data-cy="message-container" :messages="messages" />
    </div>

    <div class="chat__actions py-3 px-2">
      <UploadImage @change="onUploadFilesSelected" />

      <ChatTextField
        class="chat__text-field mx-3"
        data-cy="text-field"
        v-model="message"
        @keydown.enter="sendTextMessage"
      />

      <SendButton data-cy="button-send" @click="sendTextMessage" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import ChatMessages from "@/components/chat/ChatMessages.vue";
import ChatTextField from "@/components/chat/ChatTextField.vue";
import UploadImage from "@/components/chat/UploadImage.vue";
import SendButton from "@/components/chat/SendButton.vue";

import useMessage from "@/composition/chat/message";
import useUpload from "@/composition/chat/upload";

export default defineComponent({
  components: {
    ChatMessages,
    ChatTextField,
    UploadImage,
    SendButton
  },

  setup() {
    const {
      messages,
      message,
      sendTextMessage,
      sendImageMessage
    } = useMessage();

    const { uploadImages } = useUpload();

    async function onUploadFilesSelected(event: Event) {
      const target = event.target as HTMLInputElement;
      const files = target.files as FileList;
      const uploadedImages = await uploadImages(files);
      sendImageMessage(uploadedImages);
    }

    return {
      messages,
      message,
      sendTextMessage,
      onUploadFilesSelected
    };
  }
});
</script>

<style lang="scss" scoped>
.chat {
  display: flex;
  flex-direction: column;
}

.chat__message-container {
  height: calc(100vh - #{$footerHeight} - #{$chatActionHeight});
}

.chat__actions {
  position: fixed;
  bottom: $footerHeight;
  left: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.chat__text-field {
  flex: 1;
}
</style>
